"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteCustomerContactUpdate = exports.WaysteCustomerContactCreate = exports.CustomerContactTransport = exports.UpdateNotificationPreferences = exports.NotificationPreferences = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const nullable_1 = require("../common/nullable");
const communication_1 = require("../notification/communication");
exports.NotificationPreferences = typebox_1.Type.Unsafe(typebox_1.Type.Record(communication_1.CommunicationType, typebox_1.Type.Array(common_1.NotificationDeliveryMethod)));
exports.UpdateNotificationPreferences = typebox_1.Type.Unsafe(typebox_1.Type.Partial(typebox_1.Type.Record(typebox_1.Type.Partial(communication_1.CommunicationType), typebox_1.Type.Array(common_1.NotificationDeliveryMethod))));
exports.CustomerContactTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    email: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'email' })),
    firstName: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastName: typebox_1.Type.Optional(typebox_1.Type.String()),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    notificationPreferences: exports.NotificationPreferences,
    primaryContact: typebox_1.Type.Boolean(),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.WaysteCustomerContactCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CustomerContactTransport, ['id', 'notificationPreferences']),
    typebox_1.Type.Object({
        notificationPreferences: typebox_1.Type.Optional(exports.UpdateNotificationPreferences),
    }),
]);
exports.WaysteCustomerContactUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CustomerContactTransport, ['id', 'email', 'notificationPreferences']),
    typebox_1.Type.Object({
        email: (0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'email' })),
        notificationPreferences: exports.UpdateNotificationPreferences,
    }),
]));
//# sourceMappingURL=customer-contact-transport.js.map